module.exports = __webpack_public_path__ + "static/media/chat-CTR.2369abaa.png";